import { makeStyles } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';

const locationsPopperStyles = makeStyles(theme => createStyles({
  box: {
    position: 'absolute',
    width: '50%',
  },
  popper: {
    maxWidth: 535,
    height: '50%',
    width: '100%',
    zIndex: 10,
    [theme.breakpoints.down('sm')]: {
      minWidth: 340,
      maxWidth: 340,
    },
  },
  buttonAsAutocomplete: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      minWidth: '13rem',
    },
    [theme.breakpoints.down('sm')]: {
      width: '80vw',
    },
    height: '3rem',
    justifyContent: 'flex-start',
    color: '#4E6363 !important',
    border: `1px solid ${theme.palette.grey[400]} !important`,
    '&:hover': {
      fontWeight: '400 !important',
    },
  },
  popperOpenButtonAsAutocomplete: {
    background: '#FFFFFF !important',
    color: `${theme.palette.secondary.main} !important`,
    filter: 'none !important',
    borderColor: `${theme.palette.secondary.main} !important`,
  },
  popperOpen: {
    background: `${theme.palette.backgrounds.backgroundPopperOpen} !important`,
    filter: 'none !important',
  },
  paper: {
    marginTop: theme.spacing(1),
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    boxShadow: '0px 7px 24px rgba(26, 38, 38, 0.1)',
    padding: theme.spacing(3),
  },
  closeButton: {
    position: 'absolute',
    [theme.breakpoints.up('md')]: {
      right: theme.spacing(0.25),
    },
    [theme.breakpoints.down('md')]: {
      right: 0,
    },
    top: theme.spacing(1.25),
    color: theme.palette.grey[500],
  },
  buttonError: {
    color: 'red !important',
    border: '1px solid red !important',
  },
}));

export default locationsPopperStyles;
